import { Component } from '@angular/core';
import { WatchAccountService } from './../../../../services/watch-account.service';
import { NotificationCountersService } from './../../../../services/notification-counters.service';
import { Subscription } from 'rxjs';

@Component({
  selector: '[account-settings-side-menu]',
  template: require('./account-settings-side-menu.component.pug'),
  styles: [require('./account-settings-side-menu.component.css').toString()],
})
export class AccountSettingsSideMenuComponent {
  sub: Subscription;
  inboxErrors = 0;

  // -------------------------------------------------------------------
  constructor(
    private notificationCountersService: NotificationCountersService,
    private watchAccount: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit(): void {
    this.notificationCountersService.refresh(
      this.watchAccount.accountId().getValue(),
    );

    // this.sub = this.notificationCountersService.unaccreditedInboxesCount.subscribe(data => this.inboxErrors = data);
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
